import {Heading} from "../../../components";
import PricingTabs from "../../../components/PricingTabs";
import React, {Suspense} from "react";
import { useTranslation } from "react-i18next"


export default function Pricing() {


    const { t } = useTranslation();


    const PricingTabsGrid = [
        {
            icon: "/images/price_1.svg",
            text: "text-[#191C30E5] ",
            title: t("pricing.title.1"),
            price: t("pricing.price.1"),
            description: t("pricing.description.1"),
            bg:"bg-[#EDEDED]"
        },
        {
            icon: "/images/price_2.svg",
            text: "text-[#FFFFFF]",
            title: t("pricing.title.2"),
            price: t("pricing.price.2"),
            description: t("pricing.description.2"),
            bg:"bg-[#6C6C6C]"
        },
        {
            icon: "/images/price_3.svg",
            text: "text-[#FFFFFF]",
            title: t("pricing.title.3"),
            price: t("pricing.price.3"),
            description: t("pricing.description.3"),
            bg:"bg-[#333333]"
        },
    ]

    return (
        <>
        <section id="pricing">
            <div className="flex flex-col items-center px-6 md:px-5 sm:px-[16px]">
                <div className="container-xs flex flex-col items-start gap-10">
                    <Heading
                        size="desktop_heading_4"
                        as="h2"
                        className="sm:hidden  font-medium text-[#191c2fe5] leading-[33.6px] gap-4 uppercase">
                        {t("pricing.head_title")}
                    </Heading>
                    <div className="flex gap-5 self-stretch md:grid md:grid-cols-1 sm:grid sm:grid-cols-1">
                        <Suspense fallback={<div>Loading </div>}>
                            {PricingTabsGrid.map((d, index) => (
                                <PricingTabs {...d} key={"grid" + index}/>
                            ))}
                        </Suspense>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}